module.exports = __webpack_public_path__ + "static/media/wata.374b0228.webp";